export default "__VITE_ASSET__DZR8poU7__"